/**
 * Fetches streaming services (watch providers) for a movie using its TMDb ID.
 * @param {number} tmdbId - The TMDb ID of the movie.
 * @param {string} apiKey - Your TMDb API key.
 * @param {bool} isTvShow - Is the media a film or tvshow.
 * @returns {Promise<object>} - A promise that resolves to the watch providers categorized by country.
 */
export const fetchStreamingServices = async (tmdbId, apiKey, isTvShow) => {
  
  let url;
  if (!isTvShow)
    url = `https://api.themoviedb.org/3/movie/${tmdbId}/watch/providers?api_key=${apiKey}`;
  else
     url = `https://api.themoviedb.org/3/tv/${tmdbId}/watch/providers?api_key=${apiKey}`;

  // E.g. 
  // - Mary Queen of scots: https://api.themoviedb.org/3/movie/tt2328900/watch/providers?external_source=imdb_id&api_key=17232028b1bd9032226ab2a4200938c6
  // - We are lady parts:   https://api.themoviedb.org/3/tv/100351/watch/providers?api_key=17232028b1bd9032226ab2a4200938c6 

  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(
        `Error fetching streaming services: ${response.statusText}`,
      );
    }
    const data = await response.json();

    return data.results; // Returns the watch providers categorized by country
  } catch (error) {
    console.error('Failed to fetch streaming services:', error);
    throw error;
  }
};


